import AsyncImage from "@/AsyncImage";
import * as uf from '%/functions';
const SearchBarResultItem = (props) => {

  const {
    title = 'Whelen Blue/Blue Dual Avenger LED Dash Deck Light AVN2BB...',
    img = "//cdn11.bigcommerce.com/s-snv0ypmel9/images/stencil/250x250/products/66396/264509/avn2__33197__17563__40977__28715__33092__28849__41128__30906.1.png",
    path = "/whelen-blue-blue-dual-avenger-led-dash-deck-light-avn2bb-while-supplies-last/",
    price = '183.88',
    product_images = [{
      url: '//cdn11.bigcommerce.com/s-snv0ypmel9/images/stencil/250x250/products/66396/264509/avn2__33197__17563__40977__28715__33092__28849__41128__30906.1.png'
    }],
    id,
    brand = {name: ''}
    } = props;



  return (
    <li class="search-bar-result-item">
      <a href={'/products/' + id + '/'+(uf.convertProductNameUrl(brand?.name || 'item'))} class="">
        <div class="item-image">
          <div class="image-wrapper">
            {
              product_images[0]?.url ? 
              <AsyncImage 
                path={product_images[0].url}
              
              />
              : 
              <img alt={title} title={title} src={uf.getDefaultImage()} />
            }
            {/* <img alt={title} title={title} src={img} /> */}
          </div>
        </div>
        <div class="ss-ac-item-details">
          <p class="ss-ac-item-name ng-binding">{title}</p>
          <p class="ss-ac-item-price">
            <span class="ss-ac-item-regular ng-binding" >{uf.determinePrice(price)}</span>
          </p>
        </div>
      </a>
    </li>

  )
}

export default SearchBarResultItem;